


















import { Vue, Component } from "vue-property-decorator";

@Component
export default class LockScreen extends Vue {
  private animated = false;

  private animate() {
    if (this.animated) {
      return;
    }
    this.animated = true;
    setTimeout(() => {
      this.animated = false;
    }, 350);
  }
}
